// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

import { AdminProvider, useAdmin } from './context/AdminContext';

import Home          from './pages/Home';
import About         from './pages/About';
import Capabilities  from './pages/Capabilities';
import Workforce     from './pages/Workforce';
import GovernmentRFPs from './pages/GovernmentRFPs';
import Careers       from './pages/Careers';
import CareerDetail  from './pages/CareerDetail';
import Contact       from './pages/Contact';
import Blog          from './pages/Blog';
import BlogPost      from './pages/BlogPost';
import Admin         from './pages/Admin';
import NotFound      from './pages/NotFound';
import Navbar        from './components/Navbar';
import Footer        from './components/Footer';
import SEO           from './components/SEO';

// Scroll to top on route change
function ScrollToTopOnNav() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Protect admin routes
function ProtectedRoute({ children }) {
  const { adminUser, authLoading } = useAdmin();
  if (authLoading) return null; // wait for auth state
  if (!adminUser) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <HelmetProvider>
      <AdminProvider>
        <BrowserRouter>
          <ScrollToTopOnNav />
          <Routes>
            <Route path="/"                   element={<Home />} />
            <Route path="/about"              element={<About />} />
            <Route path="/capabilities"       element={<Capabilities />} />
            <Route path="/workforce"          element={<Workforce />} />
            <Route path="/government-rfps"    element={<GovernmentRFPs />} />
            <Route path="/careers"            element={<Careers />} />
            <Route path="/careers/:id"        element={<CareerDetail />} />
            <Route path="/contact"            element={<Contact />} />
            <Route path="/blog"               element={<Blog />} />
            <Route path="/blog/:slug"         element={<BlogPost />} />
            <Route path="/admin"              element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            {/* Legal placeholders */}
            <Route path="/privacy-policy"     element={<LegalPage title="Privacy Policy" />} />
            <Route path="/terms-of-service"   element={<LegalPage title="Terms of Service" />} />
            <Route path="/cookies"            element={<LegalPage title="Cookies Settings" />} />
            <Route path="*"                   element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AdminProvider>
    </HelmetProvider>
  );
}

// ---- Legal placeholder ----
function LegalPage({ title }) {
  return (
    <>
      <SEO title={title} />
      <Navbar variant="light" />
      <section style={{ padding: '128px 32px', minHeight: '60vh' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h1 className="title-1" style={{ marginBottom: '24px' }}>{title}</h1>
          <p className="body-lg" style={{ color: 'var(--token-desc)' }}>
            This page is under construction. Please contact us at{' '}
            <a href="mailto:admin@districtsourcingtech.com" style={{ color: 'var(--primary-500)' }}>
              admin@districtsourcingtech.com
            </a>{' '}
            for more information.
          </p>
          <Link to="/" className="btn btn-outline" style={{ marginTop: '32px', display: 'inline-flex' }}>← Back to Home</Link>
        </div>
      </section>
      <Footer />
    </>
  );
}